import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    position: "relative",
    display: "flex",
  },
  rank: {
    position: "absolute",
    left: "50%",
    top: "50%",
  },
  status: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    position: "absolute",
    zIndex: theme.zIndex.normal,
    insetInlineEnd: -theme.spacing.space4,
    top: 0,
    "&.online": {
      background: theme.colors.NotificationSuccess,
    },
    "&.offline": {
      background: theme.colors.Background5,
    },
    "&.away": {
      background: theme.colors.NotificationWarning,
    },
  },
  progress: {
    position: "absolute !important",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: -theme.zIndex.normal,
  },
}));
